import React, { useEffect, useState } from 'react'
import { ArticleTeasers } from '@ta-interaktiv/react-article-teasers'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/card.css'

import './styles.scss'

const url =
  'https://interaktiv.tagesanzeiger.ch/2020/sterne-fuer-zuerich-detailhandel/googleratings.json'

export function More(props) {
  const [data, setData] = useState([])

  useEffect(() => {
    fetch(url)
      .then(response => response.json())
      .then(d => setData(d))
      .catch(error => {
        console.error('Error:', error)
      })
  }, [])

  return (
    <div
      className='ui container'
      style={{ margin: window.innerWidth < 600 ? '1.2em 0 3em' : '0 0 3em' }}
    >
      {data.filter(d => d !== props.id).length > 0 && (
        <>
          <h4 className='teaser'>Weitere Beiträge aus dieser Serie</h4>
          <ArticleTeasers articleIds={data.filter(d => d !== props.id)} />
        </>
      )}
    </div>
  )
}

export default More
